var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":_vm.status === 1 ? 'primary' : 'danger',"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.status === 1 ? "解冻" : "冻结")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }